module.exports = __webpack_public_path__ + "img/lachskaviarsushiflambiertoben.ab4ded4a.png";